export default __webpack_public_path__ + "static/media/locked.2373ec59.svg";